import gql from "graphql-tag.macro";

import { getClient } from "Globals/api";
import { ONE_SECOND } from "Globals/constants/constants";
import { fetchDocumentsInAProject } from "Globals/dataTypes/projects/projects.api"

const query = gql`
  query notifications {
    me {
      notifications(paginate: { limit: 100 }) {
        edges {
          node {
            _id
            title
            body
            timestamp
            read
            deeplink
            tag
            data
            iconkind
          }
        }
      }
    }
  }
`;

const mutationQuery = gql`
  mutation UpdateManyNotificationsRead(
    $payload: [NotificationUpdateReadInput!]!
  ) {
    markManyNotificationsRead(notifications: $payload)
  }
`;

const subscriptionQuery = gql`
  subscription SubscribeNotification {
    notificationsUpdated {
      _id
      title
      body
      timestamp
      read
      deeplink
      tag
      data
      iconkind
    }
  }
`;

export const loadNotifications = async ({ client }) => {
  const {
    data: {
      me: { notifications: data },
    },
  } = await client.query({ query, fetchPolicy: "no-cache" });
  // if we need data from the v2 document other than the title, we can enable the below. Be careful if this is running in a refresh-query!
  if (
    window?.APPVERSION?.directory === "md" ||
    window?.APPVERSION?.directory === "s"
  ) {
    try {
      const v2Doclist = await fetchDocumentsInAProject();
      return {
        notifications: data,
        v2docs: v2Doclist,
      };
    } catch (e) {
      console.error(e);
      return { notifications: data };
    }
  }
  return { notifications: data, v2docs: [] };
};

export const updateManyNotifications = async (
  { notifications },
  { client }
) => {
  const {
    data: { markManyNotificationsRead: data },
  } = await client.mutate({
    mutation: mutationQuery,
    variables: { payload: notifications },
    fetchPolicy: "no-cache",
  });
  return data;
};

const mockSubscribeNotifications = (subject, emit) => {
  setTimeout(async () => {
    emit(await loadNotifications());
  }, ONE_SECOND);
  return () => null;
};

export const subscribeNotifications =
  window?.app?.config?.v3MockApiEnabled || process.env.STORYBOOK_IS_STORYBOOK
    ? mockSubscribeNotifications
    : async (subject, emit) => {
        const client = await getClient();
        const observable = client.subscribe({
          query: subscriptionQuery,
        });
        const subscription = observable.subscribe((val) => emit(val));
        return () => subscription.unsubscribe();
      };
